import ApiClient from '../../API/api';

const OFFERS_ENDPOINT = 'offer';

export class OfferService {
  static getAll(): Promise<any> {
    return ApiClient.performRequest(OFFERS_ENDPOINT);
  }
}